import { useMemo } from "react";
export const useUniqueId = () => {
    const uniqueId = useMemo(() => btoa(Math.random().toString()), []);
    return uniqueId;
};
